<template>
    <b-button variant="primary" v-b-tooltip.hover title="Historia" :href="url" class="mr-1">
        <i class="fas fa-book"></i>
    </b-button>
</template>
   
<script>
export default {
    name: "HistoryButton",
    props: ["url"],
}
</script>